import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Space, Button } from 'antd';
import Table from 'components/Table/index';
import { fetchGetSetoresByFilter, fetchDetalharSetorPorId } from 'store/fetchActions/fetchSetores';
import { useHistory } from 'react-router-dom';
import { widthLabel } from 'utils/stringFormatter';

export default function GridRequerimento({ filtro }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const dadosGrid = useSelector(state => state.setor.setorListar?.list);
  const paginacao = useSelector(state => state.setor.setorListar);

  const montarLinha = lista => {
    return lista?.map(item => {
      return {
        key: item?.id,
        nomeSetor: widthLabel(item?.nome, 100),
        descricaoSetor: widthLabel(item?.descricao, 100),
        ativo: item?.ativo ? 'Ativo' : 'Inativo',
      };
    });
  };

  React.useEffect(() => {
    if (unitaryTests) return;
    dispatch(fetchGetSetoresByFilter({}, 1, 10));
  }, [dispatch, unitaryTests]);

  const renderAction = row => {
    return (
      <Space>
        <Button onClick={() => dispatch(fetchDetalharSetorPorId(row?.key, history))}>Detalhar</Button>
      </Space>
    );
  };

  const changePage = (page = 1, pageSize = 10) => {
    dispatch(fetchGetSetoresByFilter(filtro, page, pageSize));
  };

  const columns = [
    {
      title: 'Nome do Setor',
      dataIndex: 'nomeSetor',
      key: 'nomeSetor',
    },
    {
      title: 'Descrição do Setor',
      dataIndex: 'descricaoSetor',
      key: 'descricaoSetor',
    },
    {
      title: 'Status',
      dataIndex: 'ativo',
      key: 'Ativo',
    },
    {
      title: '-',
      key: 'action',
      align: 'center',
      render: record => renderAction(record),
    },
  ];

  return <Table columns={columns} data={montarLinha(dadosGrid)} paginationConfig={paginacao} changePage={changePage} />;
}
